import axios from "axios";


var navigator_info = window.navigator;

const headers = {
    // 'auth-token': Auth.getAuthToken(),
    // 'device-id': Auth.deviceID,
    'origin': "127.0.0.1"

}
const Request = axios.create({
    baseURL: process.env.BaseUrl,
    timeout: 20000,
    headers: headers,
});


Request.interceptors.request.use(
    function (config) {
        return config;
    },
    function (error) {
        return Promise.reject(error);
    },
);

export default Request;